// Arbitrage API endpoints
import api from "./api";

export const arbitrageAPI = {
  // Get live arbitrage market prices
  getMarketPrices: async () => {
    try {
      const response = await api.get("/arbitrage/market-prices");
      return response.data;
    } catch (error) {
      throw error.response?.data || { error: "Failed to fetch market prices" };
    }
  },

  // Place a new arbitrage trade
  placeTrade: async ({
    pair,
    buyExchange,
    sellExchange,
    investment,
    minProfit,
    maxProfit,
    estimatedFees,
  }) => {
    try {
      const response = await api.post("/arbitrage/trade", {
        pair,
        buyExchange,
        sellExchange,
        investment,
        minProfit,
        maxProfit,
        estimatedFees,
      });
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || { error: "Failed to place arbitrage trade" }
      );
    }
  },

  // Close an existing arbitrage trade
  closeTrade: async (tradeId) => {
    try {
      const response = await api.post(`/arbitrage/trade/${tradeId}/close`);
      return response.data;
    } catch (error) {
      throw (
        error.response?.data || { error: "Failed to close arbitrage trade" }
      );
    }
  },
};
